export default __webpack_public_path__ + "static/media/CNo.83-5.cf610933.jpg";